function tripDetailsAfDpFactory({brand = '', bookingId = 0, email = ''}) {
    try {
        const targetBrand = getBrand(brand);
        const encodedEmail = encodeURIComponent(btoa(email));
        return encodeURIComponent(`${targetBrand}-app://trips/${bookingId}?enc_mail=${encodedEmail}`);
    } catch (e) {
        return '';
    }
}

function tripDetailsAfDpNotification({brand = '', bookingId = 0, website = ''}) {
    try {
        const targetBrand = getBrand(brand);
        const linkUrl = website.origin + website.pathname;
        const encodedLinkUrl = encodeURIComponent(`${linkUrl}#mybooking/refund-details/${bookingId}`);
        const encodedTitle = encodeURIComponent('Refund status');
        return encodeURIComponent(`${targetBrand}-app://openurl/?url=${encodedLinkUrl}&title=${encodedTitle}`);
    } catch (e) {
        return '';
    }
}

function getBrand(brand) {
    switch (brand.toUpperCase()) {
        case 'ED': return 'ed';
        case 'OP': return 'op';
        case 'GV': return 'go';
        case 'TL': return 'tl';
        default: throw new Error('unexpected brand');
    }
}

module.exports = {
    tripDetailsAfDpFactory,
    tripDetailsAfDpNotification,
};
